import React, { Component } from 'react';

import 'assets/css/components/logo.css';

import logoUrl from 'assets/images/logo.svg';
import logoUrlDark from 'assets/images/logo-dark.svg';

import {
  NavLink,
  withRouter
} from "react-router-dom";

function LogoImg(props) {
  return (
    <React.Fragment>
      <img src={logoUrl} className="hdr__logo-img hdr__logo-img--light logo__img" alt="Andrew Bowen's Portfolio" />
      <img src={logoUrlDark} className="hdr__logo-img hdr__logo-img--dark logo__img" aria-hidden="true" alt="Andrew Bowen's Portfolio" />
    </React.Fragment>
  );
}

function LogoWithoutLink(props) {
  return (
    <span className="hdr__logo logo">
      <LogoImg />
    </span>
  );
}

function LogoWithLink(props) {
  return (
    <NavLink to="/" className="hdr__logo logo">
      <LogoImg />
    </NavLink>
  );
}

class Logo extends Component {
  render() {

    const isHome = this.props.location.pathname === '/';
    const LogoHtml = isHome ? LogoWithoutLink : LogoWithLink ;

    return (
      <LogoHtml />
    );
  }
}

export default withRouter(Logo);



// WEBPACK FOOTER //
// ./src/Components/Logo.js